import { getFloodRiskRgba } from './floodRiskVisual';

export interface MarkerVisual {
  url: string;
  color: [number, number, number, number]; // RGBA
}

// Map sensor type to visual
export function getSensorVisual(type: string, value?: number): MarkerVisual {
  let url = '/map-icons/sensor-generic.svg';
  let color: [number, number, number, number] = [0, 255, 255, 255]; // Cyan

  switch (type) {
    case 'rainfall':
      url = '/map-icons/sensor-rainfall.svg';
      color = [135, 206, 235, 255]; // Skyblue
      break;
    case 'temperature':
      url = '/map-icons/sensor-temperature.svg';
      color = [255, 165, 0, 255]; // Orange
      break;
    case 'water_level':
      url = '/map-icons/sensor-water-level.svg';
      if (value !== undefined && value > 2.5) {
        color = [255, 0, 0, 255]; // Red
      } else {
        color = [0, 255, 255, 255]; // Cyan
      }
      break;
    case 'humidity':
      url = '/map-icons/sensor-humidity.svg';
      color = [168, 85, 247, 255]; // Purple
      break;
    case 'soil_moisture':
      url = '/map-icons/sensor-soil-moisture.svg';
      color = [34, 197, 94, 255]; // Green
      break;
  }

  return { url, color };
}

// Map flood point risk level to visual
export function getFloodPointVisual(riskLevel: number): MarkerVisual {
  return {
    url: '/map-icons/flood-point.svg',
    color: getFloodRiskRgba(riskLevel),
  };
}

// Map infrastructure type to visual
export function getInfraVisual(type: string): MarkerVisual {
  let url = '/map-icons/infra-generic.svg';
  let color: [number, number, number, number] = [0, 255, 255, 255]; // Cyan

  switch (type) {
    case 'pump':
      url = '/map-icons/infra-pump.svg';
      color = [255, 255, 0, 255]; // Yellow
      break;
    case 'culvert':
      url = '/map-icons/infra-culvert.svg';
      color = [135, 206, 235, 255]; // Skyblue
      break;
    case 'canal':
      url = '/map-icons/infra-canal.svg';
      color = [59, 130, 246, 255]; // Blue
      break;
    case 'dyke':
      url = '/map-icons/infra-dyke.svg';
      color = [100, 116, 139, 255]; // Slate
      break;
    case 'lowlying':
      url = '/map-icons/infra-lowlying.svg';
      color = [20, 184, 166, 255]; // Teal
      break;
    case 'landslide':
      url = '/map-icons/infra-landslide.svg';
      color = [255, 0, 0, 255]; // Red
      break;
  }

  return { url, color };
}
